// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3jNYo","head":"ProcedureTableInfo_head__1Xhfn"};